import { Campaign, Referral } from '../domain/Campaign';
import { ParticipantI } from '../domain/Participant';
import ReferralRepositoryI from '../repository/ReferralRepositoryI';
import ReferralServiceI from './ReferralServiceI';

export default class ReferralServiceImpl implements ReferralServiceI {
  private participantIdKeyLS = 'participantId';

  constructor(private referralRepository: ReferralRepositoryI) {
    this.referralRepository = referralRepository;
  }

  public saveParticipantIdToLS(code: string) {
    window?.localStorage.setItem(this.participantIdKeyLS, code);
  }

  public findParticipantIdFromLS(): string | null {
    return window?.localStorage.getItem(this.participantIdKeyLS);
  }

  public removeParticipantIdFromLS(): void {
    window?.localStorage.removeItem(this.participantIdKeyLS);
  }

  public async findCampaigns(customerId: string): Promise<Campaign[]> {
    return this.referralRepository.findCampaigns(customerId);
  }

  public async createParticipant(
    campaignId: string,
    customerId: string,
  ): Promise<ParticipantI> {
    return this.referralRepository.createParticipant(campaignId, customerId);
  }

  public async findParticipantById(
    campaignId: string,
    customerId: string,
  ): Promise<ParticipantI> {
    return this.referralRepository.findParticipantById(campaignId, customerId);
  }

  public async findReferralsByParticipantId(
    campaignId: string,
    participantId: string,
  ): Promise<Referral[]> {
    return this.referralRepository.findReferralsByParticipantId(
      campaignId,
      participantId,
    );
  }
}
